import { render, staticRenderFns } from "./SupportDialog.vue?vue&type=template&id=3fc4444d&"
import script from "./SupportDialog.vue?vue&type=script&lang=ts&"
export * from "./SupportDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SupportDialog.vue?vue&type=style&index=0&id=3fc4444d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports